<mat-button-toggle-group
  [value]="operatorInput()"
  (change)="operatorChange.emit($event.value)"
  class="operator-toggle">
  <mat-button-toggle [value]="QueryBlockOperator.AND">AND</mat-button-toggle>
  <mat-button-toggle [value]="QueryBlockOperator.OR">OR</mat-button-toggle>
</mat-button-toggle-group>
